<section class="auction-countdown">
  <div class="auction-countdown__header">
    <div class="auction-countdown__title-wrap">
      <i class="iconsax auction-countdown__icon" icon-name="clock"></i>
      <p class="auction-countdown__title">
        {{ 'auctions.auctionTimeRemaining' | translate }}
      </p>
    </div>

    @if (estimatedLabel()) {
      <span class="auction-countdown__estimate">EST. {{ estimatedLabel() }}</span>
    }
  </div>

  @if (isExpired()) {
    <p class="auction-countdown__expired">
      {{ 'auctions.auctionEnded' | translate }}
    </p>
  } @else {
    <div class="auction-countdown__grid">
      <div class="auction-countdown__unit">
        <span class="auction-countdown__number">{{ countdown().days }}</span>
        <span class="auction-countdown__label">{{ 'global.day' | translate }}</span>
      </div>
      <div class="auction-countdown__unit">
        <span class="auction-countdown__number">{{ countdown().hours }}</span>
        <span class="auction-countdown__label">{{ 'auctions.hours' | translate }}</span>
      </div>
      <div class="auction-countdown__unit">
        <span class="auction-countdown__number">{{ countdown().minutes }}</span>
        <span class="auction-countdown__label">{{ 'auctions.mins' | translate }}</span>
      </div>
      <div class="auction-countdown__unit">
        <span class="auction-countdown__number">{{ countdown().seconds }}</span>
        <span class="auction-countdown__label">{{ 'auctions.secs' | translate }}</span>
      </div>
    </div>
  }
</section>
